document.addEventListener('DOMContentLoaded', function() {
  const stickyBanner = document.getElementById('sticky-banner');
  const pageElements = [
    document.querySelector('[id*="sleepdoctor_sharma_lp_hero"]'),
    document.querySelector('[id*="sleepdoctor_sharma_lp_featured_product"]'),
    document.getElementById('shopify-section-lp-footer')
  ]

  if (stickyBanner !== null) {
    const intersectionCallback = (entries, observer) => {
      let bannerVisible = true;

      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              bannerVisible = false;
          }
      });

      stickyBanner.style.display = bannerVisible ? 'block' : 'none';
    };

    let intersectionOptions = {
      root: null,
      threshold: 0.1
    };

    let intersectionObserver = new IntersectionObserver(intersectionCallback, intersectionOptions);
    
    if(pageElements[0] !== null) {
      pageElements.forEach((element) => {
        if (element !== null) {
          intersectionObserver.observe(element);
        }
      });
    }
  }

  // Review Slider Style 1
  let reviewSliderStyleOne = document.getElementById('review-slider');
  if (reviewSliderStyleOne)
    {
      new Swiper('#review-slider', {
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.lp-image-with-review-next',
          prevEl: '.lp-image-with-review-prev'
        }
      });
    }


  // Review Slider Style 2
  let reviewSliderStyleTwo = document.getElementById('review-slider-peek');
  if (reviewSliderStyleTwo) {
    new Swiper('#review-slider-peek', {
      spaceBetween: 20,
      slidesPerView: 1.1,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1300: {
          slidesPerView: 3,
          touchRatio: 0
        }
      }
    });
  }

  // Review Slider Style 3
  let reviewSliderStyleThree = document.getElementById('review-slider-2col');
  if (reviewSliderStyleThree) {
    new Swiper('#review-slider-2col', {
      spaceBetween: 20,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.lp-image-with-review-next',
        prevEl: '.lp-image-with-review-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          touchRatio: 0
        }
      }
    });
  }

  // Marquee Slider
  let marqueeSlider = document.getElementById('marquee-slider');
  if (marqueeSlider) {
    new Swiper('#marquee-slider', {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 6000,
      autoplay: {
        delay: 0,
      },
      loop: true,
      slidesPerView:'auto',
      allowTouchMove: false,
      disableOnInteraction: true,
      observeParents: true,
      resizeObserver: true,
      breakpoints: {
        900: {
          centeredSlides: false,
          loop: false,
          autoplay: {
            enabled: false,
          },
          slidesPerView: 4,
          spaceBetween: 50,
          touchRatio: 0,
        }
      }
    });
    window.addEventListener('resize', function() {
      if(window.innerWidth < 900) {
        marqueeSlider.swiper.autoplay.start();
      } else {
        marqueeSlider.swiper.autoplay.stop();
      }
    });
  }

  // Content Slider
  let contentSlider = document.getElementById('content-slider');
  if (contentSlider) {
    new Swiper('#content-slider', {
      spaceBetween: 20,
      slidesPerView: 1.1,
      breakpoints: {
        500: {
          slidesPerView: 2
        },
        850: {
          slidesPerView: 3
        },
        1300: {
          slidesPerView: 4,
          touchRatio: 0
        }
      }
    });

    // Top Picks Sliders
    let topPicksSliders = document.querySelectorAll('.top-picks-slider');
    topPicksSliders.forEach(function(slider) {
      new Swiper(slider, {
        spaceBetween: 30,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        resizeObserver: true,
        breakpoints: {
          1300: {
            slidesPerView: 4,
            touchRatio: 0
          }
        }
      });
    });
  }
});